export const calculateSubPrice = (price: number, quantity: number) => (Math.round(price * 100) * quantity) / 100
